var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { staticClass: "content-container", attrs: { span: 8 } },
            [
              _c("h4", [_vm._v("手动添加")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: {
                    model: _vm.addForm,
                    rules: _vm.rules,
                    "label-width": "110px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "小组名称", prop: "groupId" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.addForm.groupId,
                            callback: function($$v) {
                              _vm.$set(_vm.addForm, "groupId", $$v)
                            },
                            expression: "addForm.groupId"
                          }
                        },
                        _vm._l(_vm.groupList, function(g, idx) {
                          return _c("el-option", {
                            key: idx,
                            attrs: { label: g.name, value: g.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服", prop: "tjkId" } },
                    [
                      _c("tjkautocompleteall", {
                        on: { change: _vm.updateAddTjkId }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addMember }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "content-container", attrs: { span: 16 } },
            [
              _c("h4", [_vm._v("成员列表")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: { model: _vm.searchForm, inline: true }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服" } },
                    [
                      _c("tjkautocompleteall", {
                        on: { change: _vm.updateTjkId }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "小组名称" } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.searchForm.groupId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "groupId", $$v)
                                },
                                expression: "searchForm.groupId"
                              }
                            },
                            _vm._l(_vm.groupList, function(g, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: { label: g.name, value: g.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.getList(1)
                            }
                          }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.list,
                    border: "",
                    "highlight-current-row": ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "客服", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(scope.row.tjkName) +
                                    "(" +
                                    _vm._s(scope.row.tjkNumber) +
                                    ")\n                        "
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.memberTagName,
                                      placement: "top"
                                    }
                                  },
                                  [
                                    scope.row.tjkTypeTag
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm._f("tagFilter")(
                                              scope.row.tjkTypeTag
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "添加时间", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(scope.row.createTime) +
                                "\n                    "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteRow(scope.row)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                attrs: { pages: _vm.pages, pageNum: _vm.searchForm.pageNum },
                on: { getData: _vm.getList }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ae05041", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae05041","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/hawkeye/memberManage.vue
// module id = 1481
// module chunks = 0